import _ from "lodash";
import { isExtendedAudioRecordingEnabled } from "Post/utils";
import React from "react";
import AudioRecorderSelector from "UIComponents/AudioRecorderSelector";

function VoiceRecorderV2(props) {
  const {
    title,
    buttonComponent,
    updatePost,
    tooltip,
    reloadText = "",
    submitText = "",
    customCallback,
    audioRecordingLimit,
    testId,
  } = props;
  const handleFile = attachment => {
    const omittedAttachment = _.omit(attachment, [
      "__typename",
      "thumbUrl",
      "signedUrl",
      "title",
      "id",
    ]);
    updatePost({ attachments: [omittedAttachment] });
    _.isFunction(customCallback) && customCallback();
  };

  const permissionWarningAlertStyle = {
    left: "50%",
    right: "50%",
    transform: "translate(-50%, -50%)",
  };
  return (
    <AudioRecorderSelector
      title={title}
      buttonComponent={buttonComponent}
      version="v4"
      updateInputField={handleFile}
      showRestartDialogV2={true}
      showStartOverDialogV2={true}
      buttonComponentTooltip={tooltip}
      reloadText={reloadText}
      submitText={submitText}
      limit={
        audioRecordingLimit
          ? audioRecordingLimit
          : isExtendedAudioRecordingEnabled()
          ? 600000
          : 300000
      }
      permissionWarningAlertStyle={permissionWarningAlertStyle}
      testId={testId}
    />
  );
}

export default VoiceRecorderV2;
